export const DEFAULT_SIZE = 240;

export const ITEM_SIZES: { [key: number]: number } = {
  640: DEFAULT_SIZE,
  920: DEFAULT_SIZE,
  1190: 330,
  1200: DEFAULT_SIZE,
  1470: 307,
  1480: DEFAULT_SIZE,
  1750: 294,
  1760: DEFAULT_SIZE,
  1920: 266
};

export const calcSize = () =>
  Object.keys(ITEM_SIZES).reduceRight((acc, item) => {
    if ((!acc || acc === DEFAULT_SIZE) && window.innerWidth >= +item) {
      return ITEM_SIZES[+item];
    }
    return acc;
  }, DEFAULT_SIZE);
